/* Newsletter Popup — runtime v3 (aquisição enriquecida)
   - Triggers: scroll 50% OU 15s OU exit intent (desktop)
   - Dismiss reaparece em N dias / Subscribed nunca mais
   - Exclui checkout, carrinho, login, conta
   - Coleta: nome (opcional), UTM, referrer, página/produto visível,
     páginas vistas na sessão, tempo no site
   - Active on Site tracking via klaviyo.identify
   - Modo debug: ?np=force ignora storage e abre rápido
*/
(function initNewsletterPopup() {

  // ============================================================
  //  SESSION TRACKING — roda sempre, independente do popup
  // ============================================================
  // Conta páginas vistas e tempo no site mesmo se o popup não abrir.
  // Permite passar esses dados como propriedades quando alguém se inscreve.
  (function trackSession() {
    try {
      var KEY = 'op:session';
      var raw = sessionStorage.getItem(KEY);
      var session = raw ? JSON.parse(raw) : null;
      if (!session) {
        session = {
          startedAt: Date.now(),
          pageViews: 0,
          firstPage: window.location.pathname,
          firstReferrer: document.referrer || '(direct)'
        };
      }
      session.pageViews = (session.pageViews || 0) + 1;
      session.lastPage = window.location.pathname;
      session.lastSeenAt = Date.now();
      sessionStorage.setItem(KEY, JSON.stringify(session));
    } catch (e) {}
  })();

  // ============================================================
  //  UTM CAPTURE — guarda UTMs da landing page
  // ============================================================
  // UTMs só existem na URL da primeira visita. Salvamos pra reusar
  // quando o popup for submetido em outra página da navegação.
  (function captureUtms() {
    try {
      var KEY = 'op:utm';
      var existing = localStorage.getItem(KEY);
      var params = new URLSearchParams(window.location.search);
      var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
      var captured = {};
      var hasAny = false;
      utmKeys.forEach(function (k) {
        var v = params.get(k);
        if (v) { captured[k] = v; hasAny = true; }
      });
      // Só sobrescreve se a URL atual TEM UTMs (não apaga o que já tinha)
      if (hasAny) {
        captured.capturedAt = Date.now();
        localStorage.setItem(KEY, JSON.stringify(captured));
      } else if (!existing) {
        // Primeira visita sem UTM: salva referrer como fallback
        localStorage.setItem(KEY, JSON.stringify({
          referrer: document.referrer || '(direct)',
          capturedAt: Date.now()
        }));
      }
    } catch (e) {}
  })();

  function getStoredUtms() {
    try {
      var raw = localStorage.getItem('op:utm');
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }

  function getSessionStats() {
    try {
      var raw = sessionStorage.getItem('op:session');
      if (!raw) return {};
      var s = JSON.parse(raw);
      return {
        page_views_in_session: s.pageViews || 1,
        first_page_in_session: s.firstPage || window.location.pathname,
        first_referrer_in_session: s.firstReferrer || '(direct)',
        time_in_session_seconds: s.startedAt ? Math.round((Date.now() - s.startedAt) / 1000) : 0
      };
    } catch (e) { return {}; }
  }

  function getPageContext() {
    var path = window.location.pathname;
    var ctx = {
      signup_url: window.location.href,
      signup_path: path,
      signup_page_title: document.title || ''
    };
    // Detecta tipo de página Shopify pelo path
    if (path.indexOf('/products/') === 0) {
      ctx.signup_page_type = 'product';
      ctx.signup_product_handle = path.split('/products/')[1].split('/')[0];
    } else if (path.indexOf('/collections/') === 0) {
      ctx.signup_page_type = 'collection';
      ctx.signup_collection_handle = path.split('/collections/')[1].split('/')[0];
    } else if (path === '/' || path === '') {
      ctx.signup_page_type = 'home';
    } else if (path.indexOf('/pages/') === 0) {
      ctx.signup_page_type = 'page';
      ctx.signup_page_handle = path.split('/pages/')[1].split('/')[0];
    } else if (path.indexOf('/blogs/') === 0) {
      ctx.signup_page_type = 'article';
    } else {
      ctx.signup_page_type = 'other';
    }
    return ctx;
  }

  // ============================================================
  //  POPUP RUNTIME
  // ============================================================
  function run() {
    try {
      var root = document.querySelector('[data-newsletter-popup]');
      if (!root) return;

      var storageKey   = root.getAttribute('data-storage-key') || 'op:newsletter-dismissed';
      var subscribedKey = root.getAttribute('data-subscribed-key') || 'op:newsletter-subscribed';
      var fallbackDelay = parseInt(root.getAttribute('data-delay'), 10) || 15000;
      var scrollPercent = parseInt(root.getAttribute('data-scroll-percent'), 10) || 50;
      var dismissDays   = parseInt(root.getAttribute('data-dismiss-days'), 10) || 7;
      var enableExitIntent = root.getAttribute('data-exit-intent') !== 'false';
      var publicKey    = root.getAttribute('data-klaviyo-public-key') || '';
      var listId       = root.getAttribute('data-klaviyo-list-id') || '';
      var source       = root.getAttribute('data-source') || 'Newsletter Popup';

      // Excluir páginas onde popup não faz sentido
      var path = (window.location.pathname || '').toLowerCase();
      var excludedPaths = ['/checkout', '/cart', '/account', '/challenge', '/password', '/orders'];
      for (var i = 0; i < excludedPaths.length; i++) {
        if (path.indexOf(excludedPaths[i]) === 0) return;
      }
      if (window.location.hostname.indexOf('checkout.') === 0) return;

      // Elementos
      var overlay      = root.querySelector('[data-np-overlay]');
      var wrap         = root.querySelector('.np-wrap');
      var form         = root.querySelector('[data-np-form]');
      var nameInput    = root.querySelector('[data-np-name]');
      var emailInput   = root.querySelector('[data-np-email]');
      var submitBtn    = root.querySelector('[data-np-submit]');
      var errorEl      = root.querySelector('[data-np-error]');
      var formView     = root.querySelector('[data-np-form-view]');
      var successView  = root.querySelector('[data-np-success-view]');
      var closers      = root.querySelectorAll('[data-np-close]');

      // ---- Storage helpers ----
      function setDismissed() {
        try {
          var expiresAt = Date.now() + dismissDays * 24 * 60 * 60 * 1000;
          localStorage.setItem(storageKey, JSON.stringify({ t: Date.now(), expires: expiresAt }));
        } catch (e) {}
      }
      function setSubscribed(email) {
        try {
          localStorage.setItem(subscribedKey, JSON.stringify({ t: Date.now(), e: email || null }));
        } catch (e) {}
      }
      function isSubscribedLocal() {
        try { return Boolean(localStorage.getItem(subscribedKey)); }
        catch (e) { return false; }
      }
      function isDismissedRecent() {
        try {
          var raw = localStorage.getItem(storageKey);
          if (!raw) return false;
          var parsed = JSON.parse(raw);
          if (!parsed || !parsed.expires) return true;
          if (Date.now() > parsed.expires) {
            localStorage.removeItem(storageKey);
            return false;
          }
          return true;
        } catch (e) { return false; }
      }

      // ---- Klaviyo helpers ----
      function isKnownInKlaviyo() {
        return new Promise(function (resolve) {
          var safety = setTimeout(function () { resolve(false); }, 800);
          var done = function (v) { clearTimeout(safety); resolve(v); };

          if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
            try {
              var result = window.klaviyo.isIdentified();
              if (result && typeof result.then === 'function') {
                result.then(done).catch(function () { done(false); });
              } else {
                done(Boolean(result));
              }
              return;
            } catch (e) {}
          }
          try {
            var match = document.cookie.match(/__kla_id=([^;]+)/);
            if (match) {
              var parsed = JSON.parse(atob(decodeURIComponent(match[1])));
              if (parsed && parsed.$email) { done(true); return; }
            }
          } catch (e) {}
          done(false);
        });
      }

      function identifyInKlaviyo(traits) {
        try {
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
            window.klaviyo.identify(traits);
            return;
          }
          window._learnq = window._learnq || [];
          // Converte traits pro formato legado ($email, $first_name, etc.)
          var legacy = {};
          if (traits.email) legacy.$email = traits.email;
          if (traits.first_name) legacy.$first_name = traits.first_name;
          if (traits.last_name) legacy.$last_name = traits.last_name;
          Object.keys(traits).forEach(function (k) {
            if (['email', 'first_name', 'last_name'].indexOf(k) === -1) legacy[k] = traits[k];
          });
          window._learnq.push(['identify', legacy]);
        } catch (e) {}
      }

      function trackKlaviyoEvent(eventName, props) {
        try {
          if (window.klaviyo && typeof window.klaviyo.track === 'function') {
            window.klaviyo.track(eventName, props);
            return;
          }
          window._learnq = window._learnq || [];
          window._learnq.push(['track', eventName, props]);
        } catch (e) {}
      }

      function splitName(full) {
        full = (full || '').trim();
        if (!full) return { first_name: null, last_name: null };
        var parts = full.split(/\s+/);
        return {
          first_name: parts[0],
          last_name: parts.length > 1 ? parts.slice(1).join(' ') : null
        };
      }

      function subscribeToKlaviyo(payload) {
        if (!publicKey || !listId) {
          return Promise.reject(new Error('Missing Klaviyo configuration'));
        }
        var profileAttrs = {
          email: payload.email,
          properties: payload.properties || {}
        };
        if (payload.first_name) profileAttrs.first_name = payload.first_name;
        if (payload.last_name) profileAttrs.last_name = payload.last_name;

        var body = {
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: profileAttrs } },
              custom_source: source
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function (res) {
          if (res.status >= 200 && res.status < 300) return true;
          return res.json().then(function (err) {
            var msg = (err && err.errors && err.errors[0] && err.errors[0].detail) || 'Subscription failed';
            throw new Error(msg);
          }).catch(function () {
            throw new Error('Subscription failed (' + res.status + ')');
          });
        });
      }

      // ---- Open/Close ----
      var hasOpened = false;
      function open() {
        if (hasOpened) return;
        hasOpened = true;
        root.hidden = false;
        void root.offsetWidth;
        overlay.setAttribute('data-open', 'true');
        wrap.setAttribute('data-open', 'true');
        document.documentElement.style.overflow = 'hidden';
        removeAllTriggers();

        // Track popup shown event no Klaviyo
        trackKlaviyoEvent('Newsletter Popup Shown', getPageContext());
      }
      function close() {
        overlay.setAttribute('data-open', 'false');
        wrap.setAttribute('data-open', 'false');
        document.documentElement.style.overflow = '';
        setDismissed();
        setTimeout(function () { root.hidden = true; }, 350);
      }

      var triggers = [];
      function addTrigger(el, evt, fn, opts) {
        el.addEventListener(evt, fn, opts || false);
        triggers.push({ el: el, evt: evt, fn: fn, opts: opts });
      }
      function removeAllTriggers() {
        for (var i = 0; i < triggers.length; i++) {
          var t = triggers[i];
          t.el.removeEventListener(t.evt, t.fn, t.opts || false);
        }
        triggers = [];
      }

      function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
      function clearError()  { errorEl.textContent = ''; errorEl.hidden = true; }

      // ---- Form submit ----
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();
        var email = (emailInput.value || '').trim();
        if (!email) return;

        var fullName = nameInput ? (nameInput.value || '').trim() : '';
        var nameParts = splitName(fullName);

        submitBtn.disabled = true;
        emailInput.disabled = true;
        if (nameInput) nameInput.disabled = true;
        var originalLabel = submitBtn.textContent;
        submitBtn.textContent = '...';

        // Monta propriedades enriquecidas
        var utms = getStoredUtms();
        var sessionStats = getSessionStats();
        var pageCtx = getPageContext();
        var properties = Object.assign(
          { source: source },
          utms,
          sessionStats,
          pageCtx
        );

        subscribeToKlaviyo({
          email: email,
          first_name: nameParts.first_name,
          last_name: nameParts.last_name,
          properties: properties
        })
          .then(function () {
            // Identify pra ativar Active on Site (cross-device tracking)
            var traits = { email: email };
            if (nameParts.first_name) traits.first_name = nameParts.first_name;
            if (nameParts.last_name) traits.last_name = nameParts.last_name;
            identifyInKlaviyo(traits);

            // Track conversion event
            trackKlaviyoEvent('Newsletter Subscribed', properties);

            setSubscribed(email);
            formView.hidden = true;
            successView.hidden = false;
            setTimeout(function () {
              overlay.setAttribute('data-open', 'false');
              wrap.setAttribute('data-open', 'false');
              document.documentElement.style.overflow = '';
              setTimeout(function () { root.hidden = true; }, 350);
            }, 2800);
          })
          .catch(function (err) {
            submitBtn.disabled = false;
            emailInput.disabled = false;
            if (nameInput) nameInput.disabled = false;
            submitBtn.textContent = originalLabel;
            showError(err.message || 'Something went wrong. Try again.');
          });
      });

      // ---- Close handlers ----
      closers.forEach(function (btn) { btn.addEventListener('click', close); });
      overlay.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !root.hidden) close();
      });

      // ============================================================
      //  DECISÃO DE EXIBIÇÃO
      // ============================================================
      var forceMode = window.location.search.indexOf('np=force') !== -1;
      if (forceMode) {
        try { localStorage.removeItem(storageKey); } catch (e) {}
        try { localStorage.removeItem(subscribedKey); } catch (e) {}
        setTimeout(open, 500);
        return;
      }
      if (isSubscribedLocal()) return;
      if (isDismissedRecent()) return;

      isKnownInKlaviyo().then(function (known) {
        if (known) { setSubscribed(); return; }
        armTriggers();
      });

      function armTriggers() {
        // 1. Timer fallback
        setTimeout(open, fallbackDelay);

        // 2. Scroll threshold
        var scrollTriggered = false;
        function onScroll() {
          if (scrollTriggered) return;
          var doc = document.documentElement;
          var scrollTop = window.pageYOffset || doc.scrollTop;
          var docHeight = (doc.scrollHeight || doc.offsetHeight) - (doc.clientHeight || window.innerHeight);
          if (docHeight <= 0) return;
          var pct = (scrollTop / docHeight) * 100;
          if (pct >= scrollPercent) { scrollTriggered = true; open(); }
        }
        addTrigger(window, 'scroll', onScroll, { passive: true });

        // 3. Exit intent (desktop)
        if (enableExitIntent && !isTouchDevice()) {
          var exitTriggered = false;
          function onMouseLeave(e) {
            if (exitTriggered) return;
            if (e.clientY <= 0 || e.relatedTarget === null) {
              exitTriggered = true;
              open();
            }
          }
          addTrigger(document.documentElement, 'mouseleave', onMouseLeave);
        }
      }
      function isTouchDevice() {
        return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
      }

    } catch (err) {
      console.error('[newsletter-popup] init failed:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
